import React, { useEffect, useState } from 'react'
import { API__ANALYTICS } from 'api'

import ComponentsList from '../../../../components/ComponentsList/ComponentsList'
import BlockSummary from '../../components/BlockSummary/BlockSummary'
import LeadFormTable from '../../components/LeadFormTable/LeadFormTable'

import Statistics from './components/Statistics/Statistics'

const WheelSpin = ({ projectId, blockProjection, dateRange, periodInterval }) => {
    const [statistic, setStatistic] = useState(null)
    const [isReady, setIsReady] = useState(false)

    const fetchData = () => {
        API__ANALYTICS.GET_WHEEL_STATISTICS({
            projectId: projectId,
            blockId: blockProjection.blockId,
            pagination: {
                from: dateRange.from,
                to: dateRange.to,
            },
        }).then(data => {
            setStatistic(data)
            setIsReady(true)
        })
    }

    useEffect(() => {
        if (dateRange) fetchData()
    }, [dateRange, blockProjection])

    return (
        <ComponentsList>
            {isReady && <BlockSummary statistic={statistic} />}
            <LeadFormTable
                projectId={projectId}
                blockProjection={blockProjection}
                dateRange={dateRange}
                periodInterval={periodInterval}
            />
            {isReady && <Statistics statistic={statistic} blockProjection={blockProjection} />}
        </ComponentsList>
    )
}

export default WheelSpin
